import React from "react";
import "./AdminAdministration.css";
import { useNavigate } from "react-router-dom"; // Importa el hook useHistory

const AdminAdministration = () => {
  const navigation = useNavigate();

  const handleCrearUsuariosButton = () => {
    navigation("/create-user");
  };
  const handleActualizarUsuariosButton = () => {
    navigation("/update-user");
  };
  const handleCrearClase = () => {
    navigation("/create-class");
  };

  const handleCrearEvaluacion = () => {
    navigation("/create-evaluation");
  };
  const handleInsertarAlumno = () => {
    navigation("/assign-class");
  };
  const handleInsertarLink = () => {
    navigation("/zoom-link");
  };

  const handleDescargarExcel = () => {
    navigation("/excel-table");
  };
  const handleSubirExcel = () => {
    navigation("/upload-excel");
  };
  const handleCrearCertificado = () => {
    navigation("/create-cert");
  };
  const handleVerCertificado = () => {
    navigation("/watch-cert");
  };
  const handleSubirNoticia = () => {
    navigation("/create-news");
  };
  return (
    <div className="administration">
      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleCrearUsuariosButton}>Crear Usuarios</button>
          <span>Genera un nuevo usuario.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleActualizarUsuariosButton}>
            Actualizar Usuarios
          </button>
          <span>Actualiza o elimina los datos de un usuario ya existente.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleCrearClase}>Crear Clase</button>
          <span>Genera clases virtuales.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleCrearEvaluacion}>Crear Evaluacion</button>
          <span>Genera evaluaciones docentes.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleInsertarAlumno}>
            Insertar Alumnos a Materias
          </button>
          <span>Asigna alumnos a las materias deseadas.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleInsertarLink}>
            Insertar link zoom a Materias
          </button>
          <span>Asigna un link de Zoom a las materias deseadas.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleSubirExcel}>Subir de excel</button>
          <span>Suba archivos de excel.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleDescargarExcel}>Ver tabla de excel</button>
          <span>Visualice archivos de excel.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleCrearCertificado}>Subir Constancias</button>
          <span>Sube las constancias para los alumnos.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleVerCertificado}>Ver Constancias</button>
          <span>Visualiza constancias de los alumnos.</span>
        </div>
        <div className="a-underline"></div>
      </div>

      <div className="admin-item">
        <div className="admin-row">
          <button onClick={handleSubirNoticia}>Crear Noticias</button>
          <span>Crea Nuevas Noticias</span>
        </div>
        <div className="a-underline"></div>
      </div>
    </div>
  );
};
export default AdminAdministration;
